<template>
  <el-dialog
    v-drag
    :visible.sync="dialogVisible"
    width="1000px"
    :title="editData.id ? '修改税率库信息' : '新增税率库信息'"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
    append-to-body
    top="3vh"
  >
    <el-form ref="form" style="margin-top: -20px;" :model="form" :rules="rules" status-icon>
      <el-row>
        <el-col :span="8">
          <el-form-item
            :label="formText.hsCode"
            :label-width="formLabelWidth80"
            prop="hsCode"
          >
            <el-input
              v-model="form.hsCode"
              :disabled="editData.hsCode ? true : false"
              oninput="value=value.replace(/[^\d]/g,'')"
              autocomplete="off"
            ></el-input> </el-form-item
          ></el-col>
        <el-col :span="8">
          <el-form-item
            :label="formText.baseRate"
            :label-width="formLabelWidth120"
            prop="baseRate"
          >
            <div class="number">
              <el-input-number
                v-model="form.baseRate"
                style="width: 100%"
                controls-position="right"
                :min="0"
                :precision="2"
                :step="0.1"
                :max="100"
              >
              </el-input-number>
            </div> </el-form-item
          ></el-col>
        <el-col :span="8">
          <el-form-item
            :label="formText.baseRateWeight"
            :label-width="formLabelWidth120"
            prop="baseRateWeight"
          >
            <div class="number">
              <el-input
                v-model="form.baseRateWeight"
                oninput="value=value.replace(/[^0-9.]/g,'')"
                autocomplete="off"
              ></el-input>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item
            :label="formText.originCountry"
            :label-width="formLabelWidth80"
            prop="originCountry"
          >
            <div class="select">
              <el-select
                v-model="form.originCountry"
                clearable
                filterable
                style="width: 100%"
                placeholder="请选择原产国"
              >
                <el-option
                  v-for="item in countryOptions"
                  :key="item.value"
                  :label="item.regionCode + '-' + item.label"
                  :value="item.regionCode"
                >
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="formText.baseRateQuantity"
            :label-width="formLabelWidth120"
            prop="baseRateQuantity"
          >
            <div class="number">
              <el-input
                v-model="form.baseRateQuantity"
                oninput="value=value.replace(/[^0-9.]/g,'')"
                autocomplete="off"
              ></el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="formText.baseRateOther"
            :label-width="formLabelWidth120"
            prop="baseRateOther"
          >
            <el-input
              v-model="form.baseRateOther"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item
            :label="formText.batchNo"
            :label-width="formLabelWidth80"
            prop="batchNo"
          >
            <el-input v-model="form.batchNo" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="formText.addRate"
            :label-width="formLabelWidth120"
            prop="addRate"
          >
            <div class="number">
              <el-input-number
                v-model="form.addRate"
                style="width: 100%"
                controls-position="right"
                :min="0"
                :precision="2"
                :step="0.1"
                :max="100"
              >
              </el-input-number>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="formText.batchNoExempt"
            :label-width="formLabelWidth120"
            prop="batchNoExempt"
          >
            <el-input
              v-model="form.batchNoExempt"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item
            :label="formText.batchNoTwo"
            :label-width="formLabelWidth80"
            prop="batchNoTwo"
          >
            <el-input v-model="form.batchNoTwo" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="formText.addRateTwo"
            :label-width="formLabelWidth120"
            prop="addRateTwo"
          >
            <div class="number">
              <el-input-number
                v-model="form.addRateTwo"
                style="width: 100%"
                controls-position="right"
                :min="0"
                :precision="2"
                :step="0.1"
                :max="100"
              >
              </el-input-number>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="formText.batchNoTwoExempt"
            :label-width="formLabelWidth120"
            prop="batchNoTwoExempt"
          >
            <el-input
              v-model="form.batchNoTwoExempt"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item
            :label="formText.batchNoThree"
            :label-width="formLabelWidth80"
            prop="batchNoThree"
          >
            <el-input v-model="form.batchNoThree" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="formText.addRateThree"
            :label-width="formLabelWidth120"
            prop="addRateThree"
          >
            <div class="number">
              <el-input-number
                v-model="form.addRateThree"
                style="width: 100%"
                controls-position="right"
                :min="0"
                :precision="2"
                :step="0.1"
                :max="100"
              >
              </el-input-number>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="formText.batchNoThreeExempt"
            :label-width="formLabelWidth120"
            prop="batchNoThreeExempt"
          >
            <el-input
              v-model="form.batchNoThreeExempt"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item
            :label="formText.batchNoFour"
            :label-width="formLabelWidth80"
            prop="batchNoFour"
          >
            <el-input v-model="form.batchNoFour" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="formText.addRateFour"
            :label-width="formLabelWidth120"
            prop="addRateFour"
          >
            <div class="number">
              <el-input-number
                v-model="form.addRateFour"
                style="width: 100%"
                controls-position="right"
                :min="0"
                :precision="2"
                :step="0.1"
                :max="100"
              >
              </el-input-number>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="formText.batchNoFourExempt"
            :label-width="formLabelWidth120"
            prop="batchNoFourExempt"
          >
            <el-input
              v-model="form.batchNoFourExempt"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item
            :label="formText.batchNoFive"
            :label-width="formLabelWidth80"
            prop="batchNoFive"
          >
            <el-input v-model="form.batchNoFive" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="formText.addRateFive"
            :label-width="formLabelWidth120"
            prop="addRateFive"
          >
            <div class="number">
              <el-input-number
                v-model="form.addRateFive"
                style="width: 100%"
                controls-position="right"
                :min="0"
                :precision="2"
                :step="0.1"
                :max="100"
              >
              </el-input-number>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="formText.batchNoFiveExempt"
            :label-width="formLabelWidth120"
            prop="batchNoFiveExempt"
          >
            <el-input
              v-model="form.batchNoFiveExempt"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item
            :label="formText.batchNoSix"
            :label-width="formLabelWidth80"
            prop="batchNoSix"
          >
            <el-input v-model="form.batchNoSix" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="formText.addRateSix"
            :label-width="formLabelWidth120"
            prop="addRateSix"
          >
            <div class="number">
              <el-input-number
                v-model="form.addRateSix"
                style="width: 100%"
                controls-position="right"
                :min="0"
                :precision="2"
                :step="0.1"
                :max="100"
              >
              </el-input-number>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="formText.batchNoSixExempt"
            :label-width="formLabelWidth120"
            prop="batchNoSixExempt"
          >
            <el-input
              v-model="form.batchNoSixExempt"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item
            :label="formText.batchNoSeven"
            :label-width="formLabelWidth80"
            prop="batchNoSeven"
          >
            <el-input v-model="form.batchNoSeven" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="formText.addRateSeven"
            :label-width="formLabelWidth120"
            prop="addRateSeven"
          >
            <div class="number">
              <el-input-number
                v-model="form.addRateSeven"
                style="width: 100%"
                controls-position="right"
                :min="0"
                :precision="2"
                :step="0.1"
                :max="100"
              >
              </el-input-number>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="formText.batchNoSevenExempt"
            :label-width="formLabelWidth120"
            prop="batchNoSevenExempt"
          >
            <el-input
              v-model="form.batchNoSevenExempt"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item
            :label="formText.batchNoEight"
            :label-width="formLabelWidth80"
            prop="batchNoEight"
          >
            <el-input v-model="form.batchNoEight" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="formText.addRateEight"
            :label-width="formLabelWidth120"
            prop="addRateEight"
          >
            <div class="number">
              <el-input-number
                v-model="form.addRateEight"
                style="width: 100%"
                controls-position="right"
                :min="0"
                :precision="2"
                :step="0.1"
                :max="100"
              >
              </el-input-number>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="formText.batchNoEightExempt"
            :label-width="formLabelWidth120"
            prop="batchNoEightExempt"
          >
            <el-input
              v-model="form.batchNoEightExempt"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="4">
          <el-form-item
            :label="formText.isSteelLicense"
            :label-width="formLabelWidth80"
            prop="isSteelLicense"
          >
            <el-radio-group v-model="form.isSteelLicense" class="radio-group-spaced">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="formText.isAluminumLicense"
            :label-width="formLabelWidth80"
            prop="isAluminumLicense"
          >
            <el-radio-group v-model="form.isAluminumLicense" class="radio-group-spaced">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="formText.isSensitive"
            :label-width="formLabelWidth80"
            prop="isSensitive"
          >
            <el-radio-group v-model="form.isSensitive" class="radio-group-spaced">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="formText.certificationItems"
            :label-width="formLabelWidth80"
            prop="certificationItems"
          >
            <el-select
              v-model="form.certificationItems"
              multiple
              filterable
              default-first-option
              placeholder="请选择认证类型"
              style="width: 100%"
            >
              <el-option
                v-for="item in itemsOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item
            :label="formText.desEN"
            :label-width="formLabelWidth80"
            prop="desEN"
          >
            <el-input
              v-model="form.desEN"
              type="textarea"
              :rows="1"
              placeholder="请输入英文描述"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            :label="formText.desCH"
            :label-width="formLabelWidth80"
            prop="desCH"
          >
            <el-input
              v-model="form.desCH"
              type="textarea"
              :rows="1"
              placeholder="请输入中文描述"
            >
            </el-input
            ></el-form-item>
        </el-col>
      </el-row>
      <el-form-item
        :label="formText.remark"
        :label-width="formLabelWidth80"
        prop="remark"
      >
        <el-input
          v-model="form.remark"
          type="textarea"
          :rows="2"
          placeholder="请输入备注"
        >
        </el-input
        ></el-form-item>
    </el-form>
    <span slot="footer" class="footers">
      <div class="cancel flex_c_c" @click="cancel">取消</div>
      <div class="ok flex_c_c" @click="ok">确定{{ editData.id ? '修改' : '新增' }}</div>
    </span>
  </el-dialog>
</template>
<script>
import { saveTaxRate, getAddressDropdown } from '@/api/basic'
import { validateRate, validateId } from '@/utils/validate'
import { mapGetters } from 'vuex'
export default {
  components: { },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number,
      default: 0 // 0 新增 1修改
    },
    editData: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    const validateMaxRate = (rule, value, callback) => {
      if (value) {
        if (
          String(value).indexOf('.') > 0 &&
          String(value).split('.').length > 2
        ) {
          callback(new Error('小数点只能一个'))
        } else if (
          String(value).indexOf('.') > 0 &&
          String(value).split('.')[1].length > 8
        ) {
          callback(new Error('只能8位小数'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      formText: {
        hsCode: '税号',
        desEN: '英文描述',
        desCH: '中文描述',
        baseRate: '货值税率(%)',
        baseRateWeight: '净重税率',
        baseRateQuantity: '数量税率',
        baseRateOther: '其它税率',
        originCountry: '原产国',
        addRate: '301加征(%)',
        batchNo: '批次号1',
        batchNoExempt: '豁免批次号1',
        batchNoTwo: '批次号2',
        addRateTwo: '122加征(%)',
        batchNoTwoExempt: '豁免批次号2',
        batchNoThree: '批次号3',
        addRateThree: '钢铝加征(%)',
        batchNoThreeExempt: '豁免批次号3',
        batchNoFour: '批次号4',
        addRateFour: '半导体税(%)',
        batchNoFourExempt: '豁免批次号4',
        batchNoFive: '批次号5',
        addRateFive: '轻型汽配加征(%)',
        batchNoFiveExempt: '豁免批次号5',
        batchNoSix: '批次号6',
        addRateSix: '铜加征(%)',
        batchNoSixExempt: '豁免批次号6',
        batchNoSeven: '批次号7',
        addRateSeven: '木制加征(%)',
        batchNoSevenExempt: '豁免批次号7',
        batchNoEight: '批次号8',
        addRateEight: '中重卡车配件(%)',
        batchNoEightExempt: '豁免批次号8',
        isSteelLicense: '钢铁许可',
        isAluminumLicense: '铝制许可',
        remark: '备注',
        isSensitive: '是否敏感',
        certificationItems: '认证项'
      },
      form: {
        hsCode: '',
        desEN: '',
        desCH: '',
        baseRate: 0.0,
        addRate: 0.0,
        batchNoTwo: '',
        addRateTwo: 0.0,
        batchNoTwoExempt: '',
        batchNoThree: '',
        addRateThree: 0.0,
        batchNoThreeExempt: '',
        batchNoFour: '',
        addRateFour: 0.0,
        batchNoFourExempt: '',
        batchNoFive: '',
        addRateFive: 0.0,
        batchNoFiveExempt: '',
        batchNoSix: '',
        addRateSix: 0.0,
        batchNoSixExempt: '',
        batchNoSeven: '',
        addRateSeven: 0.0,
        batchNoSevenExempt: '',
        batchNoEight: '',
        addRateEight: 0.0,
        batchNoEightExempt: '',
        baseRateWeight: '',
        baseRateQuantity: '',
        baseRateOther: '',
        originCountry: '',
        batchNo: '',
        isSteelLicense: false,
        isAluminumLicense: false,
        remark: '',
        isSensitive: false,
        certificationItems: []
      },
      countryOptions: [],
      itemsOptions: [
        {
          value: 0,
          label: 'FDA'
        },
        {
          value: 1,
          label: 'EPA'
        },
        {
          value: 2,
          label: 'DOT'
        },
        {
          value: 3,
          label: '反倾销'
        }
      ],
      formLabelWidth120: '120px',
      formLabelWidth80: '80px',
      formLabelWidth100: '100px',
      rules: {
        hsCode: [{ required: true, validator: validateId, trigger: 'blur' }],
        originCountry: [{ required: true, message: '请选择原产国', trigger: 'blur' }],
        baseRateWeight: [{ validator: validateMaxRate, trigger: 'blur' }],
        baseRateQuantity: [{ validator: validateMaxRate, trigger: 'blur' }],
        baseRate: [
          { required: true, validator: validateRate, trigger: 'blur' }
        ]
      },
      dialogVisible2: false
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.getcountryOption()
        if (this.editData.id) {
          this.form = {
            ...this.editData
          }
        } else {
          this.form = {
            hsCode: '',
          desEN: '',
          desCH: '',
          baseRate: 0.0,
          addRate: 0.0,
          batchNoTwo: '',
          addRateTwo: 0.0,
          batchNoTwoExempt: '',
          batchNoThree: '',
          addRateThree: 0.0,
          batchNoThreeExempt: '',
          batchNoFour: '',
          addRateFour: 0.0,
          batchNoFourExempt: '',
          batchNoFive: '',
          addRateFive: 0.0,
          batchNoFiveExempt: '',
          batchNoSix: '',
          addRateSix: 0.0,
          batchNoSixExempt: '',
          batchNoSeven: '',
          addRateSeven: 0.0,
          batchNoSevenExempt: '',
          batchNoEight: '',
          addRateEight: 0.0,
          batchNoEightExempt: '',
          baseRateWeight: '',
          baseRateQuantity: '',
          baseRateOther: '',
          originCountry: '',
          batchNo: '',
          isSteelLicense: false,
          isAluminumLicense: false,
          remark: '',
          isSensitive: false,
          certificationItems: []
          }
        }
      }
    }
  },
  methods: {
    getcountryOption() {
      getAddressDropdown().then((res) => {
        if (res.success) {
          const { data } = res
          data.country.forEach((item) => {
            item.children = null
          })
          this.countryOptions = data.country.filter(
            (country) => country.label !== 'USA'
          )
        } else {
          this.$message(res.errorMessage)
        }
      })
    },
    cancel() {
      this.$refs.form?.resetFields()
      this.$emit('cancel')
    },
    ok() {
      this.$refs.form.validate(async(valid) => {
        if (valid) {
          const params = {
            ...this.form
          }
          try {
            const res = await saveTaxRate(params)
            if (res.success) {
              this.$message.success('操作成功')
              this.$refs.form?.resetFields()
              this.$emit('ok')
            } else {
              this.$message.error(res.errorMessage)
            }
          } catch (error) {
            console.log(error)
          }
          console.log(params, saveTaxRate)
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
:deep(.el-dialog__body) {
  padding: 30px 10px;
}
.form {
    margin: 0 54px;
}
.el-form-item {
  margin-bottom: 20px;
}
.row {
  display: flex;
  justify-content: space-between;
  &:deep(.el-form-item) {
    margin-bottom: 16px;
    .el-form-item__label {
      line-height: 20px;
    }
  }
  .icon {
    font-size: 20px;
    margin-left: 10px;
    cursor: pointer;
    color:  rgb(18,88,188);
  }
}
.footers {
  width: 100%;
  display: flex;
  margin-top: -10px;
  justify-content: center;
  .cancel {
    width: 120px;
    height: 40px;
    background: #EEEEEE;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-right: 16px;
    cursor: pointer;
  }
  .ok {
    width: 120px;
    height: 40px;
    background:  rgb(18,88,188);
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    cursor: pointer;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
}
</style>
